import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CallCenterService } from "src/app/services/call-center.service";
import { MessageServiceService } from "src/app/services/message-service.service";
import { CalendarUtilityService } from "src/app/services/calendar-utility.service";
import { HealthCheckService } from "src/app/services/health-check.service";
import {
  BookcorpHealthCheckAppt,
  BookcorpHealthCheckApptRes,
} from "src/app/models/book-corp-healthcheck.model";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { de } from "date-fns/locale";
import { Subscription } from "rxjs";
import { async } from "rxjs/internal/scheduler/async";

@Component({
  selector: "app-create-healthcheck-appointment",
  templateUrl: "./create-healthcheck-appointment.component.html",
  styleUrls: ["./create-healthcheck-appointment.component.scss"],
})
export class CreateHealthcheckAppointmentComponent
  implements OnInit, OnDestroy
{
  selectedUHIDDetails: any;
  isNewUser: boolean = false;
  callType: number;
  loadingFlag: boolean = false;
  submitted: boolean;
  yearRange = "";
  slotsData: any[];
  callerStatusAutoId = 0;
  isSelectedCallBackOption = false;
  isInboundCallNewUser = false;
  isSelectedStatusUpdate = false;
  isSelectedAppointment = false;
  selectedCallStatusName;
  selectedCallStatusId;
  yearRangeDob = "";
  dobMaxDate: Date;
  callBackMinimumDate = new Date();
  corporateCustomers: any;
  corporateAgreementList: any;
  slctAgreement: any;
  corporatePackageList: any;
  selectPackage: any;
  corporateCitiesList: any;
  selectCity: any;
  selectHospital: any;
  corporateHsptlList: any;
  selectSlot: any;
  customerData: any;
  datesData: any[];
  CorpotateHcData: Subscription;
  healthCheckResKey: string;
  healthCheckRes: any;
  currentUser: [];
  currentLeadSource: string;
  data = <BookcorpHealthCheckAppt>{};

  constructor(
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private hcService: HealthCheckService,
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private calendarService: CalendarUtilityService
  ) {
    let date = new Date();
    this.dobMaxDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 1
    );
    this.yearRange = `${date.getFullYear() - 100}:${date.getFullYear()}`;
  }

  createHealthCheckCorpAppointmentForm: FormGroup;

  ngOnInit() {
    this.createHealthCheckCorpAppointmentForm = this.formBuilder.group({
      corporateCustomerName: ["", Validators.required],
      gender: ["", [Validators.required, Validators.min(1)]],
      agreementName: ["", Validators.required],
      packageName: ["", [Validators.required, Validators.min(1)]],
      city: ["", Validators.required],
      hospitalName: ["", Validators.required],
      appointmentDate: ["", Validators.required],
      appointmentSlot: ["", [Validators.required, Validators.min(1)]],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
          ),
        ],
      ],
      dateOfBirth: [""],
      patientName: ["", Validators.required],
      mobileNumber: [
        "",
        [Validators.required, Validators.pattern("[0-9]{10}")],
      ],
    });

    this.CheckPrimaryCases();
  }

  ngOnDestroy() {
    this.CorpotateHcData.unsubscribe();
  }

  leadId;
  CheckPrimaryCases() {
    //this method get the selected call status data from service
    this.CorpotateHcData = this.callCenterService.selectedCallStatus.subscribe(
      (value) => {
        this.isSelectedAppointment = true;
        this.leadId = value.LeadId;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.callerStatusAutoId = value.CallerStatusAutoId;
        this.selectedUHIDDetails = value.UHIDDetails;
        this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
        this.selectedCallStatusName = value.CallStatus["statusName"];
        if (
          this.selectedCallStatusId == 36 &&
          this.callType == 1 &&
          this.isNewUser
        ) {
          // inbound new user + create appt
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = true;
          this.loadBasicDetailsOfLead();
        } else if (this.selectedCallStatusId == 36) {
          //outbound+inbound existed user or new user.
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = false;
          if (this.isNewUser && this.callType == 2) {
            // for lead new user in outbound call only
            this.loadBasicDetailsOfLead();
          } else {
            this.loadBasicDetails();
          }
        }
      }
    );
    this.getAllcorporateCities();
  }

  loadBasicDetailsOfLead() {
    if (this.selectedUHIDDetails.firstName) {
      this.createHealthCheckCorpAppointmentForm.controls[
        "patientName"
      ].setValue(
        this.selectedUHIDDetails.firstName +
          " " +
          this.selectedUHIDDetails.lastName
      );
    }
    if (
      (this.selectedUHIDDetails["gender"] &&
        this.selectedUHIDDetails["gender"].toLowerCase() == "male") ||
      this.selectedUHIDDetails["gender"].toLowerCase() == "female"
    ) {
      this.createHealthCheckCorpAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails["gender"].toLowerCase() == "male" ? "1" : "2"
      );
      //this.createAppointmentForm.controls["gender"].disable();
    }

    if (this.selectedUHIDDetails.emailId) {
      this.createHealthCheckCorpAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
    }
    if (this.selectedUHIDDetails.phoneNo) {
      this.createHealthCheckCorpAppointmentForm.controls[
        "mobileNumber"
      ].setValue(this.selectedUHIDDetails.phoneNo);
    }
  }

  loadBasicDetails() {
    if (this.selectedUHIDDetails.firstName) {
      this.createHealthCheckCorpAppointmentForm.controls[
        "patientName"
      ].setValue(
        this.selectedUHIDDetails.firstName +
          " " +
          this.selectedUHIDDetails.lastName
      );
      this.createHealthCheckCorpAppointmentForm.controls[
        "patientName"
      ].disable();
    }
    if (
      this.selectedUHIDDetails.gender == 1 ||
      this.selectedUHIDDetails.gender == 2
    ) {
      this.createHealthCheckCorpAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails.gender + ""
      );
      this.createHealthCheckCorpAppointmentForm.controls["gender"].disable();
    }

    if (this.selectedUHIDDetails.dateOfBirth) {
      let dob = this.selectedUHIDDetails.dateOfBirth.split("/");
      this.createHealthCheckCorpAppointmentForm.controls[
        "dateOfBirth"
      ].setValue(new Date(dob[2], dob[1] - 1, dob[0]));
      this.createHealthCheckCorpAppointmentForm.controls[
        "dateOfBirth"
      ].disable();
    }

    if (this.selectedUHIDDetails.emailId) {
      this.createHealthCheckCorpAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
      this.createHealthCheckCorpAppointmentForm.controls["email"].disable();
    }

    if (this.selectedUHIDDetails.mobileNumber) {
      this.createHealthCheckCorpAppointmentForm.controls[
        "mobileNumber"
      ].setValue(this.selectedUHIDDetails.mobileNumber);
      this.createHealthCheckCorpAppointmentForm.controls[
        "mobileNumber"
      ].disable();
    }
  }

  getCorporateCustomerData(event) {
    this.customerData = event;
    this.getAllCorporateAgreements();
  }

  getAllCorporateCustomers() {
    this.loadingFlag = true;
    this.hcService.getCorporateHealthCheckCustomers("").subscribe(
      (res: any) => {
        if (res["corporateHCCustomersList"].length > 0) {
          this.corporateCustomers = res["corporateHCCustomersList"];
          this.loadingFlag = false;
        } else {
          this.messageService.showErrorMessage(
            "No corporate customers data available."
          );
        }
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve corporate customers data from server "
        );
      }
    );
  }

  CorporateCustomersByName(index, item) {
    return item.cityName;
  }

  selectAgreement(event) {
    this.slctAgreement = event;
    this.getAllCorporatePackages();
  }

  getAllCorporateAgreements() {
    let data = {
      CustomerName: this.customerData,
    };
    this.loadingFlag = true;
    this.hcService.GetAllCorporateHCAgreements(data).subscribe(
      (res: any) => {
        if (res["corporateHCAgreementsList"].length > 0) {
          this.corporateAgreementList = res["corporateHCAgreementsList"];
        } else {
          this.messageService.showErrorMessage(
            "No agreements available for selected customer."
          );
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve corporate agreements data from server "
        );
      }
    );
  }

  CorporateAgreementlistByName(index, list) {
    return list.agreementName;
  }

  getCorporatePackageList(event) {
    this.selectPackage = event;
  }

  getAllCorporatePackages() {
    let data = {
      agreementName: this.slctAgreement,
    };
    this.loadingFlag = true;
    this.hcService.GetAllCorporateHCPackages(data).subscribe(
      (res: any) => {
        if (res["corporateHCPackagesList"].length > 0) {
          this.corporatePackageList = res["corporateHCPackagesList"];
        } else {
          this.messageService.showErrorMessage(
            "No packages are available for selected agreement."
          );
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve corporate packages data from server"
        );
      }
    );
  }

  CorporatePackagesByName(index, list) {
    return list.packageName;
  }

  getCityData(event) {
    this.selectCity = event;
    this.getAllCorporateHospitals();
  }

  getAllcorporateCities() {
    this.hcService.GetAllCitieseForHCCorp("").subscribe(
      (res: any) => {
        this.loadingFlag = true;
        if (res && res.length > 0) {
          this.corporateCitiesList = res;
        } else {
          this.messageService.showErrorMessage(
            "No clinics available for selected city."
          );
        }
        this.getAllCorporateCustomers();
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve city data from server "
        );
      }
    );
  }

  CorporateCitiesByName(index, list) {
    return list.cityName;
  }

  getCorporateHospitalList(event) {
    this.selectHospital = event;
  }

  getAllCorporateHospitals() {
    let data = {
      cityId: this.selectCity,
    };
    this.loadingFlag = true;
    this.hcService.GetAllCorporateHcHospitalsByCityId(data).subscribe(
      (res: any) => {
        if (res["corporateHCHospitalsList"].length > 0) {
          this.corporateHsptlList = res["corporateHCHospitalsList"];
        } else {
          this.messageService.showErrorMessage(
            "No clinics available for selected city."
          );
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve city hospitals data from server "
        );
      }
    );
  }

  CorporateHospitalByName(index, list) {
    return list.hospitalName;
  }

  selectedAppointmentDate = "";
  getSlots(apptDate) {
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = dd.getMonth() + 1 + "";
    let year = dd.getFullYear();
    apptDate =
      (date.length == 1 ? "0" + date : date) +
      "/" +
      (month.length == 1 ? "0" + month : month) +
      "/" +
      year;
    this.selectedAppointmentDate = apptDate;
    this.getAvailableSlots();
  }

  getAvailableSlotData(event) {
    this.selectSlot = event;
  }

  getAvailableSlots() {
    let data = {
      hospitalId: this.selectHospital,
      appointmentDate: this.selectedAppointmentDate,
    };
    this.loadingFlag = true;
    this.hcService.GetAllAvailableSlots(data).subscribe(
      (res: any) => {
        if (res["corporateHCSlotsList"].length > 0) {
          this.slotsData = res["corporateHCSlotsList"];
        } else {
          this.messageService.showErrorMessage(
            "No slots available on selected date."
          );
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve available slots data from server "
        );
      }
    );
  }

  SlotsByTime(index, list) {
    return list.slotTime;
  }

  templeadSource: any;
   bookAppointmentForHcCorp(formData) {
    //debugger;
    let UserId = JSON.parse(localStorage.getItem("LOGGED_USER_INFO")).roleId;
    if (this.callType == 2) {
      this.currentUser = JSON.parse(
        localStorage.getItem("CurrentOutBoundCallMobileNumber")
      );
     this.templeadSource = this.selectedUHIDDetails["utm_source"]
        ? this.selectedUHIDDetails["utm_source"]
        : this.currentUser["leadSource"] ? this.currentUser["leadSource"] : "AHLL-CRM"
    }
    else if(localStorage.getItem("CurrentInBoundCallDetails") != null){
      this.templeadSource  = this.selectedUHIDDetails["utm_source"]
      ? this.selectedUHIDDetails["utm_source"]
      : "AHLL-CRM"
    }

    if (this.createHealthCheckCorpAppointmentForm.valid) {
      this.createHealthCheckCorpAppointmentForm.enable();
      let formDataValues = this.createHealthCheckCorpAppointmentForm.value;
      let cityObj = this.corporateCitiesList.find(
        (c) => c.cityId == formDataValues.city
      );
      let hsptlObj = this.corporateHsptlList.find(
        (h) => h.hospitalId == formDataValues.hospitalName
      );
      let slotObj = this.slotsData.find(
        (o) => o.slotId == formDataValues.appointmentSlot
      );
      (this.data.leadSource = this.templeadSource),
        (this.data.appointmentTypeId = 7),
        (this.data.hospitalId = this.selectHospital),
        (this.data.hospitalName = hsptlObj.hospitalName),
        (this.data.patientEmailId = formDataValues.email),
        (this.data.patientMobileNo = formDataValues.mobileNumber),
        (this.data.patientUHID = ""),
        (this.data.appointmentDate = this.selectedAppointmentDate),
        (this.data.slotTime = slotObj.slotTime),
        (this.data.slotId = this.selectSlot),
        (this.data.cityId = this.selectCity),
        (this.data.cityName = cityObj.cityName),
        (this.data.healthcheckId = 0),
        (this.data.healthcheckName = formDataValues.packageName),
        (this.data.customerName = formDataValues.corporateCustomerName),
        (this.data.agreementName = formDataValues.agreementName),
        (this.data.patientFirstName = formDataValues.patientName),
        (this.data.patientLastName = ""),
        (this.data.dateOfBirth = CommonMethods.changeDateFormatDDMMYYYY(
          formDataValues.dateOfBirth
        )),
        (this.data.gender = +formDataValues.gender),
        (this.data.createdby = UserId);
    }
    this.loadingFlag = true;
    this.hcService.InsertBookApptHCCorp(this.data).subscribe((res) => {
      if (res.response) {
      this.healthCheckResKey = res.response["key"];
      this.data.leadSource = "AHLL-CRM";
      this.hcService.BookApptHCCorp(this.data).subscribe(
        (res) => {
          if (res.appointmentId > 0) {
            this.healthCheckRes = res;
            this.callCenterService.afterCompleteOperationKnowTheStatus({
              callStatusId: this.selectedCallStatusId,
              callStatusName: this.selectedCallStatusName,
              isOperationDone: true,
              statusMessage: "Corp HC Appointment Created Successfully.",
            });
            this.messageService.showSuccess(res.errorMsg);
            this.createHealthCheckCorpAppointmentForm.disable();
            this.UpdateHealthCheck();
          } else {
            this.messageService.showErrorMessage(res.errorMsg);
          }
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to book appointment, An error occur while booking appointment."
          );
        }
      );
      }
      else{
        this.messageService.showErrorMessage(res.errorMsg);
      }
    },
    (err) => {
      if (err.status === 401) {
        this.messageService.showErrorMessage(
          "Your session has been expired."
        );
      } else if (err.status === 400) {
        this.messageService.showErrorMessage(err.error.Message);
      } else {
        this.messageService.showErrorMessage("Something went wrong");
      }
    }
    );
   
    
  }

  UpdateHealthCheck() {
   // debugger;
    this.hcService
      .UpdateBookApptHCCorp(this.healthCheckResKey, this.healthCheckRes)
      .subscribe(
        (res: any) => {
          console.log(res.response, "final");
          this.messageService.showSuccess(res.response["statusMessage"]);
          this.loadingFlag = false;
        },
        (err) => {
          this.loadingFlag = false;
          if (err.status === 401) {
            this.messageService.showErrorMessage(
              "Your session has been expired."
            );
          } else if (err.status === 400) {
            this.messageService.showErrorMessage(err.error.Message);
          } else {
            this.messageService.showErrorMessage("Something went wrong");
          }
        }
      );
  }
}
